// 普通发票退票
export const commonList1 = [
  { label: '退票编号', value: 'subNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '发票编号', value: 'invoiceCode' },
  { label: '发票金额', value: 'amount' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' }
]

export const commonList2 = [
  { label: '退票编号', value: 'subNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '发票编号', value: 'invoiceCode' },
  { label: '发票金额', value: 'amount' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '退票类型', value: 'type' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' },
  { label: '认领人', value: 'processUser' },
  { label: '认领时间', value: 'processDate' }
]
export const commonList3 = [
  { label: '退票编号', value: 'subNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '发票编号', value: 'invoiceCode' },
  { label: '发票金额', value: 'amount' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '退票类型', value: 'type' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' },
  { label: '认领时间', value: 'processDate' }
]
export const commonList4 = [
  { label: '退票编号', value: 'subNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '发票编号', value: 'invoiceCode' },
  { label: '发票金额', value: 'amount' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '退票类型', value: 'type' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' },
  { label: '退票状态', value: 'state' },
  { label: '处理时间', value: 'processDate' },
  { label: '处理人', value: 'processUser' }
]

export const commonListRed4 = [ // (ok)
  { label: '退票编号', value: 'subNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '原发票编号', value: 'invoiceNumber' },
  { label: '原发票金额', value: 'amount' },
  { label: '红字信息表编号', value: 'invoiceRedCode' },
  { label: '红字发票编号', value: 'invoiceRedNumber' },
  { label: '红字发票金额', value: 'redAmonut' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '退票类型', value: 'type' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' },
  { label: '退票状态', value: 'state' },
  { label: '处理时间', value: 'processDate' },
  { label: '处理人', value: 'processUser' }
]
